import { MapUtils } from '../../../../utility/map-utils.js';
import { cloneData, isSameData } from '../../../dto/data-model-utils.js';
import {
  SerializedData, SerializationContext, DataModelBuilder,
} from '../../../dto/data-model.js';
import { OnlineProductOrder } from '../../online-product-order.js';
import { AuditLogEntryType } from '../audit-log-entry-type.js';
import { AuditLogEntry } from '../audit-log-entry.js';

export class OnlineProductOrderRefundedEntry extends AuditLogEntry {
  static readonly TYPE_ID: string = '5d5a4ec00bc148ecaec661386eb7e451';

  private constructor(
    public readonly before: OnlineProductOrder,
    public readonly after: OnlineProductOrder,
  ) {
    super();
  }

  get $typeId(): string {
    return OnlineProductOrderRefundedEntry.TYPE_ID;
  }

  get type(): AuditLogEntryType {
    return AuditLogEntryType.OnlineProductOrderRefunded;
  }

  generateQueryData(): SerializedData {
    return {
      businessRef: this.after.businessRef.encode(),
      orderId: this.after.uniqueId,
      customerId: this.after.creatorId,
      isGuestOrder: this.after.isGuestOrder,
    };
  }

  static create(args: {
    before: OnlineProductOrder,
    after: OnlineProductOrder,
  }): OnlineProductOrderRefundedEntry {
    return new OnlineProductOrderRefundedEntry(
        args.before,
        args.after,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): OnlineProductOrderRefundedEntry {
    return this.create({
      before: context.fromData<OnlineProductOrder>(MapUtils.getRecord(map, 'before')),
      after: context.fromData<OnlineProductOrder>(MapUtils.getRecord(map, 'after')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      before: context.toData(this.before),
      after: context.toData(this.after),
    };
  }

  clone(): this {
    return OnlineProductOrderRefundedEntry.create({
      before: cloneData(this.before),
      after: cloneData(this.after),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.before, this.before) &&
           isSameData(other.after, this.after);
  }
}

export class OnlineProductOrderRefundedEntryBuilder extends DataModelBuilder<OnlineProductOrderRefundedEntry> {
  build(context: SerializationContext, map: SerializedData): OnlineProductOrderRefundedEntry {
    return OnlineProductOrderRefundedEntry.fromMap(context, map);
  }
}
